/**
 * The space's render look, shown live in the 3D view (photoPreview.ts) — and
 * its lens (lensPreview.ts) — without the render controls bar. The customer's
 * designer has no bar (RenderControls is the admin sandbox's, since
 * 2026-10-29: docs/DESIGNER-V3.md "Render controls — admin only"), but the
 * view must still show the look the room's render will get. RenderControls
 * does the same for itself (with the window's edits on top), so a host mounts
 * one or the other, never both: pass undefined where the bar is up.
 */

import { useEffect } from 'react';
import { previewRenderSettings } from '../../ui/room3d/renderSettings';
import { setLensPreview } from '../../ui/room3d/lensPreview';
import { photoPreviewSettings } from '../../ui/room3d/photoPreview';
import type { RenderLook } from '../../ui/room3d/renderLooks';
import { useRenderSettings } from './useRenderSettings';

export function useLookPreview(look: RenderLook | undefined): void {
  const settings = useRenderSettings();
  const photo = look?.photo;
  useEffect(() => {
    if (!photo) return undefined;
    previewRenderSettings(photoPreviewSettings(settings, photo));
    setLensPreview(photo.camera.lensType === 'perspective' ? photo.camera.focalMm : null);
    return () => { previewRenderSettings(null); setLensPreview(null); };
  }, [settings, photo]);
}
